import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    filterAll: 'Все',
    filterDrafts: 'Черновики',
    filterLink: 'По ссылке',
    filterPublic: 'В каталоге',
    searchPlaceholder: 'Найти инструкцию по названию',
    deleted: 'Удалено',
    author: 'Автор',
    newInstruction: 'Новая инструкция',
    draft: 'Черновик',
    menu: 'Меню',
    open: 'Открыть',
    delete: 'Удалить',
    emptyAll: 'Ой, а инструкций пока нет…',
    emptyDrafts: 'Ой, а черновиков нет…',
    emptyPublic: 'Ой, а опубликованных инструкций пока нет…',
    emptyLink: 'Ой, а инструкций по ссылке нет…',
    createFirst: 'Создать первую',
    createInstruction: 'Создать инструкцию',
  },
  en: {
    filterAll: 'All',
    filterDrafts: 'Drafts',
    filterLink: 'By link',
    filterPublic: 'In catalog',
    searchPlaceholder: 'Find an article by title',
    deleted: 'Article deleted',
    author: 'Author',
    newInstruction: 'New article',
    draft: 'Draft',
    menu: 'Menu',
    open: 'Open',
    delete: 'Delete',
    emptyAll: 'Oops, no articles yet…',
    emptyDrafts: 'Oops, no drafts yet…',
    emptyPublic: 'Oops, no published articles yet…',
    emptyLink: 'Oops, no articles available by link yet…',
    createFirst: 'Create your first article',
    createInstruction: 'Create article',
  },
})
